import React from 'react';
import { Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import logo from "../../assets/sign.png";

const borderColor = '#3778C2'
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        
        position: "relative",
        alignItems: 'center',
        height: 24,
        fontSize: 12,
        fontStyle: 'bold',
        marginTop:20
    },
    description: {
        width: '80%',
        textAlign: 'right',
       
        paddingRight: 8,
    },
    total: {
        width: '15%',
        textAlign: 'right',
        paddingRight: 8,
    },
    sign: {
        width: 48,
        height: 48,
        position: "absolute",
        top: -35,
        right: 50,
    },
});

const InvoiceTableFooter = ({ items }) => {
    const total = items.map(item => item.qty * item.rate)
        .reduce((accumulator, currentValue) => accumulator + currentValue, 0)
    return (
        <View style={styles.row}>
            <Text style={styles.description}>
                Email: contactus@analahinsurance.com
            </Text>
            <Image style={styles.sign} src={logo} />
            <Text style={styles.description}>
                Website: www.royalcover.in
            </Text>
        </View>
    )
};

export default InvoiceTableFooter;